/**
 * document/conversationApi.js — Sprint 1 refactor (2026-05-20)
 *
 * Trước: REACT_APP_OPENAI_KEY + user_token query param + /stream(/free).
 * Sau:   gateway POST /api/v1/llm-gateway/chat/stream với JWT, tool='document'.
 *
 * Backend routing → Claude Sonnet 4.6 (long context cho document viewer).
 * RAG/citation vẫn đi qua /api/answer (fetchAnswerApi) — server-side.
 */

import { store } from 'store';
import apiSlice from 'store/slices/apiSlice';
import { streamChatLegacy, RateLimitError } from '../_shared/llmGateway';
import { authManager } from 'utils/authManager';

const apiHost = process.env.REACT_APP_API_URL || '/api/v1';
const TOOL = 'document';

const DOC_SYSTEM_PROMPT =
    'You are a document Q&A assistant. Answer concisely using the provided context. Cite sources by document name when possible.';

export async function fetchAnswerApi(question, _apiKey, selectedDocs, history = [], conversationId) {
    const auth = authManager.getToken();
    const headers = { 'Content-Type': 'application/json' };
    if (auth) headers.Authorization = `Bearer ${auth}`;

    const cleanHistory = history.map((item) => ({ prompt: item.prompt, response: item.response }));

    const res = await fetch(`${apiHost}/answer`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
            question,
            history: cleanHistory,
            selected_docs: selectedDocs,
            conversation_id: conversationId,
            project: TOOL,
        }),
    });
    if (!res.ok) throw new Error(res.statusText || 'fetchAnswerApi failed');
    const data = await res.json();
    return {
        answer: data.answer,
        query: question,
        result: data.answer,
        sources: data.sources,
        conversationId: data.conversation_id,
    };
}

/**
 * Streaming Q&A. Chữ ký cũ:
 *   fetchAnswerSteaming(question, model, apiKey, selectedDocs, history, conversationId, onEvent)
 */
export function fetchAnswerSteaming(
    question,
    model,
    _apiKey,
    _selectedDocs,
    history = [],
    _conversationId,
    onEvent,
    opts = {}
) {
    return streamChatLegacy({
        tool: TOOL,
        question,
        history,
        model,
        systemPrompt: opts.systemPrompt || DOC_SYSTEM_PROMPT,
        signal: opts.signal,
        onEvent,
    }).catch((e) => {
        if (e instanceof RateLimitError) {
            onEvent?.(new MessageEvent('message', { data: JSON.stringify({ type: 'error', detail: e.message, tool: TOOL, status: 429 }) }));
        }
        throw e;
    });
}

export async function sendFeedback(prompt, response, feedback) {
    const res = await store.dispatch(
        apiSlice.endpoints.postChatFeedback.initiate({
            question: prompt,
            answer: response,
            feedback,
            project: TOOL,
        })
    );
    if (res?.data !== undefined || res?.isSuccess) return Promise.resolve();
    return Promise.reject(new Error('sendFeedback failed'));
}
